import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MethodService } from '@/infra/services/method';
import { QUERY_KEYS } from '@/utils/query-keys';

interface DeleteMethodParams {
	readonly organization_id?: string;
	readonly company_id?: string;
	readonly id: string;
}

const Service = MethodService.getInstance();

export const useDeleteMethod = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: DeleteMethodParams) => Service.delete(params),
		onError: () => {
			message.error(I18n.get('Error deleting method'));
		},
		onSuccess: async (_data, variables) => {
			await queryClient.invalidateQueries([QUERY_KEYS.GET_METHOD_LIST_OPTIONS, variables]);
		}
	});
};
